export default [
  {
    title: "breadcrumb.report",
    icon: "BarChart2Icon",
    children: [
      {
        title: "breadcrumb.conversationOverview",
        route: "conversation-overview",
        icon: "",
        resource: "report-conversation-overview",
        action: "read",
      },
      {
        title: "breadcrumb.teamPerformance",
        route: "report-team-performance",
        icon: "",
        resource: "dashboard",
        action: "read",
      },
      {
        title: "breadcrumb.customerSatification",
        route: "report-customer-satisfaction",
        icon: "",
        resource: "dashboard",
        action: "read",
      },
      {
        title: "breadcrumb.callSatisfaction",
        route: "call-satisfaction",
        icon: "",
        resource: "report-call-satisfaction",
        action: "read",
      },
    ],
  },
];
